module.exports = __webpack_public_path__ + "assets/img/word-study-practice.68204db0.png";